/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.26.0
 */

import { RadioButton } from '@/main/components/common';
import { IPageSettingsTranslation } from '@/main/modules/internationalization/types/pages/pageSettings';

import { PageSettingsHeaderStyled } from '../../styled/PageSettingsStyled';
import { ESettingsProfilePreferredLK } from '../settingsProfileConstants';
import { ISettingsProfilePreferredLK, TSettingsProfileSetParamPreferredLKActionPayload } from '../settingsProfileTypes';
import { SettingsProfilePreferredLKContainerStyled } from '../styled/SettingsProfileStyled';

export interface ISettingsProfilePreferredLKProps {
    params: ISettingsProfilePreferredLK;
    setParam: (payload: TSettingsProfileSetParamPreferredLKActionPayload) => void;
    translation: IPageSettingsTranslation;
}

export const SettingsProfilePreferredLK = ({ params, setParam, translation }: ISettingsProfilePreferredLKProps) => {
    const onRadioChangeHandler = (preferred: ESettingsProfilePreferredLK) => {
        setParam({ preferred });
    };

    return (
        <>
            <PageSettingsHeaderStyled>{translation.profile.preferredLK.header}</PageSettingsHeaderStyled>

            <SettingsProfilePreferredLKContainerStyled>
                <RadioButton
                    checked={params.preferred === ESettingsProfilePreferredLK.B2B}
                    dataName={ESettingsProfilePreferredLK.B2B}
                    label={translation.profile.preferredLK.preferred.b2b}
                    name="preferred"
                    type="radio"
                    onChange={() => onRadioChangeHandler(ESettingsProfilePreferredLK.B2B)}
                />
                <RadioButton
                    checked={params.preferred === ESettingsProfilePreferredLK.SOHO}
                    dataName={ESettingsProfilePreferredLK.SOHO}
                    label={translation.profile.preferredLK.preferred.soho}
                    name="preferred"
                    type="radio"
                    onChange={() => onRadioChangeHandler(ESettingsProfilePreferredLK.SOHO)}
                />
            </SettingsProfilePreferredLKContainerStyled>
        </>
    );
};
